import { Component, OnDestroy, OnInit } from '@angular/core';

import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { LiftStatsComponent } from '../lift-stats/lift-stats.component';
import { DateRangeBannerService } from '../../services/date-range-banner.service';

@Component({
	selector: 'app-lift-stats-v2',
	styleUrls: ['./lift-stats-v2.component.css'],
	templateUrl: './lift-stats-v2.component.html'
})
export class LiftStatsV2Component extends LiftStatsComponent implements OnInit, OnDestroy {
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected dateRangeBannerService: DateRangeBannerService
	) {
		super(analyticsService, analyticsDataModel, dateRangeBannerService);
	}

	ngOnInit(): void {
		if (this.sectionclass.toLowerCase().includes('r6') || this.sectionclass.toLowerCase().includes('v6')) {
			this.isR6Enabled = true;
		}
		super.ngOnInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
}
